<div id="table_drivers_stat" class="tablewrap resizetable tabpage hidden">
    <div class="table tableinfo">
      <table fixedcols="[]" id="driversstattable">
        <tr>
          <th class="object_column">{{'Driver'|translate}}</th>
          <th>{{'Internal ID'|translate}}</th>
          <th>{{'Rating'|translate}}</th>
          <th class="time_column">{{'Working time'|translate}}</th>
          <th class="mileage_column">{{'Mileage'|translate}}</th>
          <th class="speed_column">{{'Max speed'|translate}}</th>
          <th>{{'Fuel consumption'|translate}}</th>
          <th>{{'Violations'|translate}}</th>
          <th>{{'Violations duration'|translate}}</th>
          <th>{{'Penalty'|translate}}</th>
        </tr>
      </table>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'driversstattable'"></app-pagination>
</div>
